import { render, staticRenderFns } from "./fileUpload.vue?vue&type=template&id=4de89e48&"
import script from "./fileUpload.vue?vue&type=script&lang=js&"
export * from "./fileUpload.vue?vue&type=script&lang=js&"
import style0 from "./fileUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4de89e48')) {
      api.createRecord('4de89e48', component.options)
    } else {
      api.reload('4de89e48', component.options)
    }
    module.hot.accept("./fileUpload.vue?vue&type=template&id=4de89e48&", function () {
      api.rerender('4de89e48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/comment/components/fileUpload.vue"
export default component.exports